import { SVGProps } from 'react'

export const RoundCheckboxBold = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className="round-checkbox-icon"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.8058 9.16821L11.985 16.3779L8.28027 12.8731"
        stroke={props.stroke || '#FF7F6B'}
        strokeWidth="3"
      />
      <path
        className="tick"
        d="M13.1602 24.25C19.3734 24.25 24.4102 19.2133 24.4102 13C24.4102 6.7868 19.3734 1.75 13.1602 1.75C6.94696 1.75 1.91016 6.7868 1.91016 13C1.91016 19.2133 6.94696 24.25 13.1602 24.25Z"
        stroke={props.stroke || '#FF7F6B'}
        strokeWidth="3"
      />
    </svg>
  )
}
